// extracted by mini-css-extract-plugin
export default {"configuration":"configuration__TWIbPF_1","settings":"settings__k1lcD1nV"};